import type React from 'react';
import { useCallback } from 'react';
import { useYieldCallback } from '@zillow/yield-callback';
import { shareButtonCX } from './srpShareButton.styles';
import { SrpShareIcon } from './SrpShareIcon';
import type { ListingDetails } from 'app/types/listingDetails.type';
import { useShareAction } from 'app/shared/hooks/useShareAction';

type SrpShareButtonProps = {
  listing: ListingDetails;
};

const SrpShareButton = ({ listing }: SrpShareButtonProps) => {
  const openShare = useShareAction({
    listing,
    triggerLocation: 'search_results',
    triggerObject: 'property_card',
  });

  const yieldShareClick = useYieldCallback(openShare);

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      yieldShareClick();
    },
    [yieldShareClick],
  );

  return (
    <button
      type="button"
      aria-label={`Share ${listing.displayName}`}
      className={shareButtonCX}
      data-name="SrpShareButton"
      onClick={handleClick}
    >
      <SrpShareIcon />
    </button>
  );
};

export default SrpShareButton;
